import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";
import { categoryFormGroupsApi } from "./categoryFormGroupsApi";

export const useCategoryFormGroups = (categoryId?: string | number) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.CATEGORY_FORM_GROUPS(categoryId!),
    queryFn: () => categoryFormGroupsApi.fetchGroups(Number(categoryId)),
    enabled: !!categoryId,
  });

  return { isLoading, groups: data?.data ?? [], refetch };
};
